import pdf from "@react-pdf/renderer";
import React from "react";

const {Document: PDFDocument, Image, Page, StyleSheet, Text, View} = pdf;

export const PDFModeContext = React.createContext(true);

export const Document = ({
  children,
}: {
  style: any;
  htmlStyle?: any;
  children: any;
}) => {
  return <PDFDocument>{children}</PDFDocument>;
};

export const Body = ({
  style,
  children,
}: {
  style: any;
  htmlStyle?: any;
  children: any;
}) => {
  const pdfStyle = StyleSheet.create(style);
  return (
    <Page size="A4" style={pdfStyle}>
      {children}
    </Page>
  );
};
export const Div = ({
  style,
  children,
  wrap,
}: {
  style?: any;
  htmlStyle?: any;
  children?: any;
  wrap?: boolean;
}) => {
  const pdfStyle = StyleSheet.create(style);
  return (
    <View style={pdfStyle} {...(wrap === undefined ? {} : {wrap})}>
      {children}
    </View>
  );
};

export const Img = ({style, src}: {style: any; htmlStyle?: any; src: string}) => {
  const pdfStyle = StyleSheet.create(style);
  return <Image style={pdfStyle} src={src} />;
};

export const P = ({style, children}: {style?: any; htmlStyle?: any; children: any}) => {
  if (style) {
    const pdfStyle = StyleSheet.create(style);
    return <Text style={pdfStyle}>{children}</Text>;
  }
  return <Text>{children}</Text>;
};

export const Hr = ({style}: {style: any; htmlStyle?: any}) => {
  const pdfStyle = StyleSheet.create(style);
  return <View style={pdfStyle} />;
};
